import React from "react";
import DataFileList from "./DataFileList";
import { DataFileModel } from "../api/vehicleFileAPI";
import { Button } from "react-bootstrap";
import { PlusCircleFill } from "react-bootstrap-icons";
import { DataFileEntry } from "../common/fileUtils";

interface DataFilesProps {
  files: DataFileEntry[];
  multiple: boolean;
  disabled: boolean;
  onView: (fullPath: string) => void;
  onDownload: (fullPath: string) => void;
  onDelete: (fullPath: string) => void;
  onUpdate: (file: DataFileModel) => void;
  onAdd: () => void;
}

function DataFiles({
  files,
  multiple,
  disabled,
  onView,
  onDownload,
  onDelete,
  onUpdate,
  onAdd,
}: DataFilesProps) {
  return (
    <>
      {files.length > 0 && (
        <>
          <DataFileList
            files={files}
            isDisabled={disabled}
            onView={onView}
            onDownload={onDownload}
            onDelete={onDelete}
            onUpdate={onUpdate}
          />
          {multiple && <div className="mb-3"></div>}
        </>
      )}

      {(multiple || files.length === 0) && (
        <Button
          type="button"
          onClick={onAdd}
          disabled={disabled}
          variant="outline-primary"
        >
          <PlusCircleFill
            style={{
              display: "inline-block",
              verticalAlign: "-.125em",
              fill: "currentcolor",
            }}
          />{" "}
          {multiple ? "Add File(s)" : "Add File"}
        </Button>
      )}
    </>
  );
}

export default DataFiles;
